import { render } from "./EditPage.vue?vue&type=template&id=50cb26f0&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"

import "./EditPage.vue?vue&type=style&index=0&id=50cb26f0&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb26f0"]])

export default __exports__